import { render, staticRenderFns } from "./GlobalInputTextfield.vue?vue&type=template&id=77bdd468&scoped=true&"
import script from "./GlobalInputTextfield.vue?vue&type=script&lang=js&"
export * from "./GlobalInputTextfield.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bdd468",
  null
  
)

export default component.exports